import React from 'react'
import { ClockIcon } from "@heroicons/react/20/solid"

const TeacherCalendarSmallEventsSection = ({selectedDay, setOpenEvent}) => {
  const [sortedEvents, setSortedEvents] = React.useState(selectedDay.events)
  
  React.useEffect(() => {
    let sortedArray = selectedDay.events
    setSortedEvents([...sortedArray.sort(function compare(a,b) {return new Date(a.dateTime) - new Date(b.dateTime)})])
  }, [selectedDay])

    return (
        <div className="py-1 px-0 w-full sm:px-6 lg:hidden">
          <ol className="divide-y divide-gray-100 overflow-hidden rounded-lg m-0 bg-white text-sm h-auto max-h-52 overflow-y-scroll">
            {sortedEvents.map((event) => (
              <li key={event.id} onClick={() => setOpenEvent(event)} className="group flex px-4 py-1 pr-6 focus-within:bg-gray-50 border-solid border border-blue-500 bg-blue-100 rounded-lg my-2 cursor-pointer shadow hover:bg-gray-50">
                <div className="flex-auto">
                  <p className="font-extrabold inline-block text-blue-900 m-0">{event.name}</p>
                  {event.isIntro && <p className="inline-block text-xs border-solid border border-green-500 text-green-500 px-2 rounded-full ml-2">Intro Lesson</p>}
                  <time dateTime={event.datetime} className="m-0 flex items-center text-xs text-blue-500">
                    <ClockIcon className="mr-2 h-4 w-4 text-gray-400" aria-hidden="true" />
                    {event.time}
                  </time>
                </div>
                <a href={event.href} className="ml-6 flex-none self-center rounded-md border border-gray-300 bg-white py-2 px-3 font-semibold text-gray-700 opacity-0 shadow-sm hover:bg-gray-50 focus:opacity-100 group-hover:opacity-100">
                  Edit<span className="sr-only">, {event.name}</span>
                </a>
              </li>
            ))}
          </ol>
        </div>
    )
}
export default TeacherCalendarSmallEventsSection